import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/lib/i18n/config';

/**
 * Header dropdown for switching UI language.
 *
 * Persists the choice via i18next's `localStorage` cache (`ett.lng`). No page
 * reload needed — components re-render through the `useTranslation` hook.
 */
export function LanguageSwitcher() {
  const { i18n, t } = useTranslation('common');
  const current = (i18n.resolvedLanguage ?? 'en') as SupportedLanguage;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={t('language.switch')}
          title={t('language.switch')}
        >
          <Languages className="h-4 w-4" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-36">
        {SUPPORTED_LANGUAGES.map((lng) => (
          <DropdownMenuItem
            key={lng}
            onSelect={() => void i18n.changeLanguage(lng)}
            className={lng === current ? 'font-medium text-brand-900' : ''}
          >
            {t(`language.${lng}`)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
